// /chatbot de configuración. El cliente vuelve al inicio.
// El superadmin cae en la ficha del cliente, pestaña Chatbot.

import { createFileRoute, redirect } from '@tanstack/react-router';
import {
  configRouteRedirect,
  readSelectedTenantId,
  superadminDeepConfigTarget,
} from '~/lib/config-access';
import { currentUser } from '~/lib/pb';

export const Route = createFileRoute('/_authed/chatbot')({
  beforeLoad: () => {
    const dest = configRouteRedirect(currentUser()?.role, '/chatbot');
    if (dest) throw redirect(dest);
    const deep = superadminDeepConfigTarget({ path: '/chatbot' }, readSelectedTenantId());
    if (deep) throw redirect(deep);
    throw redirect({ to: '/clientes' });
  },
});
